<template>
    <b-form @submit.stop.prevent="saveContract" novalidate="novalidate" autocomplete="off">
        <div class="row">
            <div class="col-4">
                <div class="form-group bmd-form-group is-filled">
                    <label for="client" class="bmd-label-floating">Cliente:</label>
                    <input refs="client" type="text" class="form-control" v-model="contract.client.name" disabled="" />
                </div>
            </div>
            <div class="col-4">
                <div class="form-group bmd-form-group is-filled">
                    <label for="contract" class="bmd-label-floating">Contrato:</label>
                    <input refs="contract" type="text" class="form-control" v-model="contract.physical_proposal" disabled="" />
                </div>
            </div>
            <div class="col-4">
                <div class="form-group bmd-form-group is-filled">
                    <label for="representative_id" class="bmd-label-floating">Grupo / Cota:</label>
                    <input refs="group_quota" type="text" class="form-control" v-model="contract.group + ' / ' + contract.quota" disabled="" />
                </div>
            </div>
        </div>
        <br />
        <h5 >Dados de endereço:</h5>
        <hr />
        <div class="row">
            <div class="col-md-4">
                <h6 class="card-title">CEP</h6>
                <p class="card-category">{{ contract.client_address.cep | cep }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <h6 class="card-title">Endereço</h6>
                <p class="card-category">{{ contract.client_address.address }}</p>
            </div>
            <div class="col-md-2">
                <h6 class="card-title">Número</h6>
                <p class="card-category">{{ contract.client_address.number }}</p>
            </div>
            <div class="col-md-4">
                <h6 class="card-title">Bairro</h6>
                <p class="card-category">{{ contract.client_address.borough }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <h6 class="card-title">Complemento</h6>
                <p class="card-category">{{ contract.client_address.complement }}</p>
            </div>
            <div class="col-md-6">
                <h6 class="card-title">Cidade</h6>
                <p class="card-category">{{ contract.client_address.city.name }}/{{ contract.client_address.city.state.abbreviation }}</p>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-4">
                <div class="form-group bmd-form-group is-filled"
                    v-bind:class="{'has-danger': validation.representative_id != '' }">
                    <label for="representative_id" class="bmd-label-floating">Representante <span class="text-danger">*</span></label>
                    <model-list-select 
                        class="form-control"
                        :list="representatives"     
                        option-value="id"
                        option-text="name"
                        v-model="form.representative_id"
                        :isDisabled="!canEditData || (isSalesman && !form.is_with_the_salesman)">
                    </model-list-select>
                    <label v-if="validation.representative_id != ''" class="error" for="representative_id">{{ validation.representative_id }}</label>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group bmd-form-group is-filled"
                    v-bind:class="{'has-danger': validation.contract_status_id != '' }">
                    <label for="contract_status_id" class="bmd-label-floating">Status <span class="text-danger">*</span></label>
                    <model-list-select 
                        class="form-control"
                        :list="contract_statuses"     
                        option-value="id"
                        option-text="status"
                        v-model="form.contract_status_id"
                        :isDisabled="!canEditData || (isSalesman && !form.is_with_the_salesman)">
                    </model-list-select>
                    <label v-if="validation.contract_status_id != ''" class="error" for="contract_status_id">{{ validation.contract_status_id }}</label>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group bmd-form-group is-filled"
                    v-bind:class="{'has-danger': validation.situation != '' }">
                    <label for="situation" class="bmd-label-floating">Situação <span class="text-danger">*</span></label>
                    <model-list-select 
                        class="form-control"
                        :list="situations"     
                        option-value="id"
                        option-text="name"
                        v-model="form.situation"
                        :isDisabled="!canEditSituatio || (isSalesman && !form.is_with_the_salesman)">
                    </model-list-select>
                    <label v-if="validation.situation != ''" class="error" for="situation">{{ validation.situation }}</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h3 v-bind:style="{'color': contract_statuses.length > 0 && contract_statuses.find((status) => status.id == form.contract_status_id).is_pending && validation.pending_reasons != '' ? 'red' : 'black' }">
                    Pendências
                    <span class="text-danger"
                        v-if="contract_statuses.length > 0 && contract_statuses.find((status) => status.id == form.contract_status_id).is_pending"
                    >*</span>
                </h3>
            </div>
        </div>
        <div class="row">
            <div class="col-3" v-for="reason in pending_reasons" :key="reason.id">
                <div class="form-group">
                    <label for="pending_reasons" class="bmd-label-floating">
                        <b-form-checkbox
                            v-model="form.pending_reasons"
                            :value="reason.id"
                        >
                            {{ reason.description }}
                        </b-form-checkbox>
                    </label>
                </div>
            </div>
            <div class="col-12">
                <label v-if="contract_statuses.length > 0 && contract_statuses.find((status) => status.id == form.contract_status_id).is_pending && validation.pending_reasons != ''" class="error" for="pending_reasons">{{ validation.pending_reasons }}</label>
            </div>
        </div>
        <hr />
        <h5 v-if="contract.contract_remarkers.length > 0">Interações:</h5>
        <div class="row" v-for="iterator in contract.contract_remarkers">
            <div class="col-4">
                <div class="form-group bmd-form-group">
                    <label>
                        <strong>De:</strong><br />
                        {{ iterator.source_user.name }}
                    </label>
                </div>
            </div>
            <div class="col-8">
                <div class="form-group bmd-form-group">
                    <label>
                        <strong>Mensagem:</strong><br />
                        {{  iterator.text ? iterator.text : '--' }}<br />
                        <small>({{ iterator.created_at | moment("DD/MM/YYYY") }} às {{ iterator.created_at | moment('HH:mm') }})</small>
                    </label>
                </div>
            </div>
        </div>
        <div class="row" v-if="!(isSalesman && !form.is_with_the_salesman)">
            <div class="col-12">
                <div
                class="form-group bmd-form-group"
                :class="{'is-filled': !!form.text, 'has-danger': validation.text != '' }"
                >
                    <label for="text" class="bmd-label-floating">Mensagem</label>
                    <b-form-textarea
                        data-vv-name="text"
                        v-validate="validation.text"
                        id="text"
                        v-model="form.text"
                    ></b-form-textarea>
                    <label v-if="validation.text != ''" class="error" for="text">{{ validation.text }}</label>
                </div>
            </div>
        </div>
        <b-button :disabled="loading || (isSalesman && !form.is_with_the_salesman)" type="submit" variant="primary">Salvar</b-button>
    </b-form>
</template>

<script>
import 'moment'

export default {
    $_veeValidate: {
        validator: "contract_update" // give me my own validator scope.
    },
    computed: {
        contract: {
            set(contract) {},
            get() {
                this.form.id = this.$store.state.contracts.item.id;
                this.form.situation = this.$store.state.contracts.item.situation;
                this.form.contract_status_id = this.$store.state.contracts.item.contract_status_id;
                this.form.representative_id = this.$store.state.contracts.item.representative_id;
                this.form.is_with_the_salesman = this.$store.state.contracts.item.is_with_the_salesman;
                if (this.$store.state.contracts.item.pending_reasons.length > 0) {
                    this.form.pending_reasons = this.$store.state.contracts.item.pending_reasons.map(reason => reason.id);
                }
                return this.$store.state.contracts.item;
            }
        },
        contract_statuses: {
            set(contract_statuses) {},
            get() {
                return this.$store.state.contract_status.itens
            }
        },
        isSalesman() {
            if (this.$store.state.auth != undefined) {
                if (this.$store.state.auth.user != undefined) {
                    if (this.$store.state.auth.user.profile != undefined) {
                        return this.$store.state.auth.user.profile.type_profile_id == 4;
                    }
                }
            }
            return true;
        },
        pending_reasons: {
            set(pendingReasons) {},
            get() {
                return this.$store.state.pending_reasons.itens
            }
        },
        representatives: {
            set(representatives) {},
            get() {
                return this.$store.state.users.itens
            }
        }
    },
    data() {
        return {
            canEditData: this.$store.state.auth.user.profile.type_profile_id <= 3,
            canEditSituatio: this.$store.state.auth.user.profile.type_profile_id <= 4,
            form: {
                id: "",
                contract_status_id: "",
                pending_reasons: [],
                representative_id: "",
                situation: "",
                text: "",
                is_with_the_salesman: false
            },
            loading: false,
            situations: [
                {
                    id: "A",
                    name: "Alocada"
                },
                {
                    id: "C",
                    name: "Cancelada"
                },
                {
                    id: "N",
                    name: "Não alocada"
                }
            ],
            validation: {
                contract_status_id: '',
                pending_reason_id: "",
                representative_id: '',
                situation: '',
                text: ''
            }
        };
    },
    created() {
        this.getContract();
    },
    methods: {
        async getContract() {
            this.$root.$emit("onLoading");

            await this.$store.dispatch(
                "contracts/get",
                this.$route.params.id
            );

            await this.$store.dispatch(
                "contract_status/all"
            )

            await this.$store.dispatch(
                "pending_reasons/all"
            )

            await this.$store.dispatch("users/all", 'type_profile_id=4&branch_id=' + this.$store.state.auth.user.branch_id);

            this.$root.$emit("onLoading");
        },
        async saveContract() {
            var self = this;
            var valid = true;
            self.validation = {
                contract_status_id: '',
                pending_reasons: "",
                representative_id: '',
                situation: '',
                text: ''
            }

            if (self.form.contract_status_id == "" || self.form.contract_status_id == null) {
                self.validation.contract_status_id = 'Campo obrigatório!';
                valid = false;
            }
            if (self.form.representative_id == "" || self.form.representative_id == null) {
                self.validation.representative_id = 'Campo obrigatório!';
                valid = false;
            }
            if (self.form.situation == "" || self.form.situation == null) {
                self.validation.situation = 'Campo obrigatório!';
                valid = false;
            }

            if (self.contract_statuses.length > 0 && self.contract_statuses.find((status) => status.id == self.form.contract_status_id).is_pending && self.form.pending_reasons.length == 0) {
                console.log(self.form.pending_reasons.length);
                self.validation.pending_reasons = "Campo obrigatório!";
                console.log(self.validation);
                valid = false;
            }
            // if (self.form.text == "" || self.form.text == null) {
            //     self.validation.text = 'Campo obrigatório!';
            //     valid = false;
            // }

            if (valid){
                self.loading = true;
                self.$root.$emit('onLoading');

                var response = await self.$store.dispatch(
                    "contracts/edit",
                    self.form
                )
            
                this.loading = false;
                this.$root.$emit("updateList");
                this.$root.$emit("hideModal");
                this.$notify.success('Formalização atualizada com sucesso');
                this.$root.$emit("onLoading");
            }
        },
    }
};
</script>